import React from "react";

import arrayMutators from "final-form-arrays";
import createDecorator from "final-form-focus";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { useGetApplicationQuery, useUploadedFilesQuery, useUploadFilesMutation } from "RegisterBenAdmin/api";
import LoadingPage from "RegisterBenAdmin/components/LoadingPage";
import { BenAdminLeadUpdatableProps } from "RegisterBenAdmin/types";

import Chrome from "../components/Chrome";
import { doneURL } from "../urls";
import BodyText from "Cobalt/BodyText";
import Button from "Cobalt/Button";
import { CardSection } from "Cobalt/Card";
import { H4 } from "Cobalt/Header";
import { SIFinalFormMultiFileInput, SIFinalFormField } from "Common/forms";
import { Row, Col } from "Common/Grid";
import { Div, Ul } from "Common/HTML";

const focusOnErrors = createDecorator();

interface SubmitProps extends BenAdminLeadUpdatableProps {
  files: File[];
}
const PlanUploadPage = () => {
  const { data: { benAdminLead } = {}, isLoading: isLoadingBenAdminLead } = useGetApplicationQuery();
  const id = benAdminLead?.externalID;
  const history = useHistory();
  const { data: { files: uploadedFiles } = {} } = useUploadedFilesQuery({ storageKey: "insurance" }, { skip: !id });
  const [uploadFiles] = useUploadFilesMutation();

  const submitHandler = async ({ files }: SubmitProps) => {
    if (files?.length > 0) {
      const uploadInsuranceFilesRes = await uploadFiles({ files, storageKey: "insurance" });
      if (uploadInsuranceFilesRes.error) {
        const { errors } = uploadInsuranceFilesRes.error.data;
        return errors;
      }
    }

    history.push(doneURL);
    return null;
  };

  return isLoadingBenAdminLead ? (
    <LoadingPage />
  ) : (
    <Chrome title="Partner Broker Upload Benefit Plans">
      <Form
        onSubmit={submitHandler}
        decorators={[focusOnErrors]}
        initialValues={{
          ...benAdminLead,
        }}
        mutators={{
          ...arrayMutators,
        }}
      >
        {({ handleSubmit }) => {
          return (
            <form onSubmit={handleSubmit}>
              <CardSection>
                <H4>Plan Information for {benAdminLead?.companyName}</H4>
              </CardSection>
              <CardSection>
                <Row>
                  <Col sm={8}>
                    <BodyText>Upload plan and pricing documents (SBCs, Invoices, etc.) for any of the following benefits:</BodyText>
                    <BodyText size="small">
                      <Ul pl={4} my={3}>
                        <li>Medical</li>
                        <li>Dental</li>
                        <li>Vision</li>
                        <li>Life</li>
                        <li>Disability</li>
                        <li>AD&D</li>
                      </Ul>
                    </BodyText>
                  </Col>
                  {uploadedFiles?.length && uploadedFiles.length > 0 ? (
                    <Col sm={4}>
                      <Div>
                        <BodyText weight="bold">Previously Uploaded Plan Files</BodyText>
                        <BodyText size="small" my={3}>
                          {uploadedFiles.map((file, index) => (
                            <div className="text-ellipsis" key={`${file}_${index}`}>
                              {file}
                            </div>
                          ))}
                        </BodyText>
                      </Div>
                    </Col>
                  ) : null}
                  <SIFinalFormField name="files" component={SIFinalFormMultiFileInput} />
                </Row>
              </CardSection>
              <CardSection className="flex border-t-1 border-0 border-solid border-t-gray-300">
                <Button ml="auto" type="submit" size="medium">
                  Next
                </Button>
              </CardSection>
            </form>
          );
        }}
      </Form>
    </Chrome>
  );
};

export default PlanUploadPage;
